document.addEventListener('DOMContentLoaded', function () {
  const lang = (Shopify.locale || 'en').toLowerCase();
  const supportedLangs = ['it', 'fr'];

  // If the language is not one we translate, do nothing (form stays in default/English placeholder text)
  if (!supportedLangs.includes(lang)) return;

  // Dictionary of TEXT FRAGMENTS exactly as they appear in individual text nodes inside the
  // Klaviyo form. Some sentences are split across multiple text nodes because of nested tags
  // (e.g. <em>, <u>), so each fragment is listed separately to avoid destroying those tags.
  const dictionary = {
    // Title (wrapped in <em>)
    'is your size not available?': {
      it: 'la tua taglia non è disponibile?',
      fr: 'votre taille n’est pas disponible ?',
    },
    // Subtitle
    'we can send you an email when it’s available again.': {
      it: 'ti avviseremo via email quando sarà di nuovo disponibile.',
      fr: 'nous vous enverrons un email dès qu’il sera de nouveau disponible.',
    },
    // Email field label (screen-reader only)
    email: {
      it: 'email',
      fr: 'email',
    },
    // Promotional consent checkbox text
    'i consent to receiving promotional communications.': {
      it: 'acconsento a ricevere comunicazioni promozionali.',
      fr: 'je consens à recevoir des communications promotionnelles.',
    },
    // accessibility label
    'check this box to also receive promotional marketing emails.': {
      it: 'seleziona questa casella per ricevere anche email di marketing promozionale.',
      fr: 'cochez cette case pour recevoir également des emails de marketing promotionnel.',
    },
    // Privacy text, split into 3 fragments because of the <u>privacy policy</u> tag in the middle
    'i confirm that i have read the': {
      it: 'confermo di aver letto la',
      fr: 'je confirme avoir lu la',
    },
    'privacy policy': {
      it: 'privacy policy',
      fr: 'politique de confidentialité',
    },
    'for the back in stock purpose.': {
      it: 'per la finalità di back in stock.',
      fr: 'dans le cadre du retour en stock.',
    },
    // Submit button
    'notify me': {
      it: 'avvisami',
      fr: 'me prévenir',
    },
    // Success message title (shown after form submission, wrapped in <em>)
    'thank you for subscribing to our out of stock notification': {
      it: 'grazie per esserti iscritto alla nostra notifica di back in stock',
      fr: 'merci de vous être inscrit à notre notification de retour en stock',
    },
    // Success message subtitle (shown after form submission)
    'you will receive an email as soon as the item is back in stock.': {
      it: 'riceverai un’email non appena l’articolo sarà di nuovo disponibile.',
      fr: 'vous recevrez un email dès que l’article sera de nouveau en stock.',
    },
  };

  // Email input placeholder is an attribute, not a text node, so it's handled separately
  const placeholderDictionary = {
    'email *': {
      it: 'email *',
      fr: 'email *',
    },
  };

  const buttonDictionary = {
    'notify me': {
      it: 'avvisami',
      fr: 'me prévenir',
    },
  };

  // Returns the leading/trailing whitespace of a string, so we can preserve spacing
  // around the translated text (important for fragments split across tags)
  function getWhitespace(text) {
    return {
      leading: text.match(/^\s*/)[0],
      trailing: text.match(/\s*$/)[0],
    };
  }

  // Walk every text node inside the form and translate it if its trimmed content
  // matches a dictionary entry. Only the text node's data is modified, so any
  // surrounding tags (em, u, span, etc.) are left completely untouched.
  function translateTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
    const nodesToTranslate = [];

    let currentNode;
    while ((currentNode = walker.nextNode())) {
      const trimmed = currentNode.textContent.trim().toLowerCase();
      if (dictionary[trimmed] && dictionary[trimmed][lang]) {
        nodesToTranslate.push(currentNode);
      }
    }

    nodesToTranslate.forEach(function (node) {
      const trimmed = node.textContent.trim().toLowerCase();
      const translation = dictionary[trimmed][lang];
      const { leading, trailing } = getWhitespace(node.textContent);
      node.textContent = leading + translation + trailing;
    });
  }

  // Translate the email input placeholder attribute separately (not a text node)
  function translatePlaceholder(form) {
    const emailInput = form.querySelector('input[type="email"]');
    if (!emailInput) return;

    const ph = (emailInput.placeholder || '').trim().toLowerCase();
    if (placeholderDictionary[ph] && placeholderDictionary[ph][lang]) {
      emailInput.placeholder = placeholderDictionary[ph][lang];
    }
  }

  function translateForm(form) {
    translateTextNodes(form);
    translatePlaceholder(form);
  }

  // Translate the BIS trigger button text inside #klaviyo-bis-button-container
  // using the dedicated buttonDictionary (separate from the form dictionary)
  function translateBisButton() {
    const container = document.querySelector('#klaviyo-bis-button-container');
    if (!container) return;

    const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
    const nodesToTranslate = [];

    let currentNode;
    while ((currentNode = walker.nextNode())) {
      const trimmed = currentNode.textContent.trim().toLowerCase();
      if (buttonDictionary[trimmed] && buttonDictionary[trimmed][lang]) {
        nodesToTranslate.push(currentNode);
      }
    }

    nodesToTranslate.forEach(function (node) {
      const trimmed = node.textContent.trim().toLowerCase();
      const translation = buttonDictionary[trimmed][lang];
      const { leading, trailing } = getWhitespace(node.textContent);
      node.textContent = leading + translation + trailing;
    });
  }

  let formObserver = null;

  // Start observing the DOM for the Klaviyo form being injected (it loads asynchronously)
  function startFormObserver() {
    if (formObserver) return; // already running, avoid duplicates

    formObserver = new MutationObserver(function () {
      document.querySelectorAll('form.klaviyo-form').forEach(function (form) {
        // Always re-run translation on any DOM change inside the form.
        // This covers both the initial render and the success message that
        // replaces the form's content after submission. translateTextNodes()
        // only touches text nodes that still match an untranslated dictionary
        // entry, so already-translated text is simply skipped (safe to re-run).
        translateForm(form);
      });

      // Translate the BIS button container whenever it appears in the DOM
      translateBisButton();
    });

    formObserver.observe(document.body, { childList: true, subtree: true });
  }

  // Stop and clean up the observer when it's no longer needed
  function stopFormObserver() {
    if (formObserver) {
      formObserver.disconnect();
      formObserver = null;
    }
  }

  // Check whether the Back in Stock trigger button is present in the DOM,
  // and start/stop the form observer accordingly
  function checkTriggerAndToggleObserver() {
    const triggerExists = !!document.querySelector('.klaviyo-bis-trigger');
    if (triggerExists) {
      startFormObserver();
      // Also attempt immediate translation in case the button container
      // is already present in the DOM (no mutation needed)
      translateBisButton();
    } else {
      stopFormObserver();
    }
  }

  // Initial check on page load
  checkTriggerAndToggleObserver();

  // Re-check every time the selected variant changes (Prestige theme event)
  document.addEventListener('variant:change', checkTriggerAndToggleObserver);
});
